// GENERATED by atlas-design-system/project/marketing/press/build.mjs - do not edit.
// Edit kit.json there and re-run the build.

export const PRESS_KIT = {
  "version": "1.0",
  "updated": "8 October 2026",
  "tagline": "The record of your time outside.",
  "contact": {
    "name": "Jack Burt",
    "role": "Maker",
    "email": "hello@goatlas.co.uk"
  },
  "stores": {
    "ios": null,
    "android": null
  },
  "boilerplate": {
    "oneLine": "Atlas matches the walks you have already recorded against the UK's peaks, trails, landmarks and regions, and keeps the record for you.",
    "short": "Atlas is the record of your time outside. Connect Strava, Apple Health or Health Connect, or upload GPX files, and Atlas matches your walks against 2,965 peaks, 40 long-distance trails (all sixteen National Trails among them), 7,323 landmarks and 18 regions. Collections fill in, regions colour up, and nothing needs logging by hand.",
    "long": [
      "Atlas is the record of your time outside. It connects to the tracker you already use (Strava, Apple Health, Health Connect, or plain GPX files) and matches every recorded walk, hike and run against a curated map: 2,965 classified hills (nearly all of them in the UK), 40 long-distance trails including all sixteen National Trails, 7,323 landmarks and 18 national parks and upland regions.",
      "The result is a map of everywhere you have been, 68 collections to complete (the Wainwrights, the Munros, the Ethels, trig points and more), coverage figures for each region, 250+ achievements and an Outdoor Score.",
      "Atlas does not plan routes, navigate or record activities. Other apps do that well. Atlas is what happens afterwards. It is free to use, with a one-off Full history purchase that matches a walker's whole archive and a Pro plan for the extras, and it is available on the web, iOS and Android."
    ]
  },
  "factSheet": [
    {
      "label": "Product",
      "value": "Atlas"
    },
    {
      "label": "What it is",
      "value": "A lifetime record of outdoor exploration, built automatically from recorded activities"
    },
    {
      "label": "Website",
      "value": "goatlas.co.uk"
    },
    {
      "label": "Platforms",
      "value": "Web, iOS (iPhone and iPad), Android"
    },
    {
      "label": "Coverage",
      "value": "United Kingdom"
    },
    {
      "label": "Sources",
      "value": "Strava, Apple Health, Health Connect, GPX upload (including Garmin, Komoot and AllTrails exports)"
    },
    {
      "label": "Dataset",
      "value": "2,965 peaks, 40 long-distance trails including all sixteen National Trails, 7,323 landmarks (of which 6,436 trig points), 18 regions, 68 collections, 250+ achievements"
    },
    {
      "label": "Collections include",
      "value": "Wainwrights, Munros, Corbetts, Fionas, Donalds, Hewitts, Nuttalls, Marilyns, Birketts, Ethels, Outlying Fells, county tops, Munro Tops, the Mournes, trig points, bothies, waterfalls, stone circles"
    },
    {
      "label": "Price",
      "value": "Free. Full history is £14.99 once. Atlas Pro is £2.99 a month or £24.99 a year, and the annual plan includes Full history"
    },
    {
      "label": "Free plan",
      "value": "Matches the last 12 months of activities against every collection, with 3 GPX uploads a month, 1 custom list and 1 personal route check a month"
    },
    {
      "label": "Full history",
      "value": "A one-off £14.99 purchase. Atlas matches the whole archive, for every source including ones connected later, with no monthly GPX upload limit. Kept for good"
    },
    {
      "label": "Atlas Pro",
      "value": "Unlimited personal route checks, Insights (forecasts, trends, records and visit stats), Wrapped, unlimited custom lists, 250 Waypoints a month and offline maps on mobile. Monthly does not include Full history; annual does"
    },
    {
      "label": "What it does not do",
      "value": "Plan routes, navigate or record activities"
    },
    {
      "label": "Made by",
      "value": "Jack Burt. Independent, made in the UK"
    },
    {
      "label": "Press contact",
      "value": "hello@goatlas.co.uk"
    }
  ],
  "factsAsOf": "26 October 2026",
  "founder": {
    "name": "Jack Burt",
    "role": "Maker",
    "greeting": "Hello, I'm Jack. I made Atlas.",
    "story": [
      "I'm a software engineer and a hiker from the UK. I love being in the hills, but work keeps me at a desk most of the week, so I don't get out nearly as much as I'd like.",
      "I'm also a bit of a completionist. Show me a list of 214 fells and I will want all 214.",
      "I had years of walks sitting in Strava and a pile of GPX files, and nothing that turned them into a decent record. The traditional bagging sites are brilliant, but you have to log everything yourself, and I know I'd never keep that up. Newer apps can pick summits out of your history, which was closer, but I wanted more than summits.",
      "I wanted to know how much of a national park I'd actually walked. Which long-distance trails I'd covered sections of without noticing. Which trig points I'd passed. I walked the South Downs Way and wanted that to actually count towards something.",
      "So I built it myself. You connect the tracker you already use, and Atlas matches your walks against peaks, trails, trig points, landmarks and regions. It deliberately doesn't record activities or plan routes. There are already plenty of apps that do those things really well.",
      "It's UK only for now. I know the geography here far better than I know anywhere else, so I'd rather get that right first.",
      "If you're writing about Atlas, everything you need is below. If you have questions, including the nerdy ones about how the matching works, send them my way."
    ],
    "signoff": "Jack",
    "photoCaption": "Jack Burt, who made Atlas, at a summit pillar in the usual weather.",
    "photo": "/press-kit/founder/jack-burt-atlas-founder.jpg",
    "photoCrop": "/press-kit/founder/jack-burt-atlas-founder-crop.jpg",
    "photoCropSize": {
      "width": 800,
      "height": 1000
    }
  },
  "brand": {
    "naming": [
      "The product is called Atlas. Write it with a capital A, not in capitals.",
      "The web address is goatlas.co.uk. The product is not called GoAtlas.",
      "The paid plans are Full history and Atlas Pro. The score is the Outdoor Score."
    ],
    "colours": [
      {
        "name": "Summit Gold",
        "hex": "#F4B740",
        "use": "The brand colour. Achievement, completion and the logo."
      },
      {
        "name": "Ink",
        "hex": "#0C1117",
        "use": "The canvas. Atlas is dark by default."
      },
      {
        "name": "Paper",
        "hex": "#E9EDF1",
        "use": "Light backgrounds."
      },
      {
        "name": "Sky",
        "hex": "#46B6E8",
        "use": "In progress."
      },
      {
        "name": "Spruce",
        "hex": "#37BE76",
        "use": "Completed and explored."
      },
      {
        "name": "Coral",
        "hex": "#F2705A",
        "use": "Alerts."
      }
    ],
    "type": [
      {
        "name": "Space Grotesk",
        "use": "Headings, figures and the wordmark"
      },
      {
        "name": "Hanken Grotesk",
        "use": "Body text"
      },
      {
        "name": "Space Mono",
        "use": "Data labels, in capitals"
      }
    ],
    "logoDo": [
      "Use the gold or white logo on dark backgrounds and the ink logo on light ones.",
      "Leave clear space around the logo of at least half the height of the mark.",
      "Keep the mark at 16 px or taller and the lockup at 80 px or wider.",
      "Over photography, use the white logo and pick a quiet part of the image."
    ],
    "logoDont": [
      "Recolour, stretch, rotate or outline the logo.",
      "Rebuild the wordmark in another typeface.",
      "Add shadows, glows or other effects.",
      "Use the logo in a way that suggests Atlas endorses or is partnered with you."
    ]
  },
  "usage": [
    "Everything in this kit may be used, free of charge, for editorial coverage of Atlas: news, reviews, features, podcasts and videos.",
    "Please do not alter the logo, and do not use these assets in a way that implies endorsement by, or partnership with, Atlas.",
    "Photographs are by Jack Burt. A credit of \"Atlas\" or \"Jack Burt / Atlas\" is appreciated but not required.",
    "For anything else, including commercial use, ask first: hello@goatlas.co.uk."
  ],
  "logos": [
    {
      "id": "lockup-horizontal",
      "label": "Horizontal lockup",
      "variants": [
        {
          "colour": "gold-gradient",
          "svg": "/press-kit/logos/svg/atlas-lockup-horizontal-gold-gradient.svg",
          "png": "/press-kit/logos/png/atlas-lockup-horizontal-gold-gradient-3000w.png"
        },
        {
          "colour": "gold",
          "svg": "/press-kit/logos/svg/atlas-lockup-horizontal-gold.svg",
          "png": "/press-kit/logos/png/atlas-lockup-horizontal-gold-3000w.png"
        },
        {
          "colour": "white",
          "svg": "/press-kit/logos/svg/atlas-lockup-horizontal-white.svg",
          "png": "/press-kit/logos/png/atlas-lockup-horizontal-white-3000w.png"
        },
        {
          "colour": "ink",
          "svg": "/press-kit/logos/svg/atlas-lockup-horizontal-ink.svg",
          "png": "/press-kit/logos/png/atlas-lockup-horizontal-ink-3000w.png"
        }
      ]
    },
    {
      "id": "lockup-stacked",
      "label": "Stacked lockup",
      "variants": [
        {
          "colour": "gold-gradient",
          "svg": "/press-kit/logos/svg/atlas-lockup-stacked-gold-gradient.svg",
          "png": "/press-kit/logos/png/atlas-lockup-stacked-gold-gradient-3000w.png"
        },
        {
          "colour": "gold",
          "svg": "/press-kit/logos/svg/atlas-lockup-stacked-gold.svg",
          "png": "/press-kit/logos/png/atlas-lockup-stacked-gold-3000w.png"
        },
        {
          "colour": "white",
          "svg": "/press-kit/logos/svg/atlas-lockup-stacked-white.svg",
          "png": "/press-kit/logos/png/atlas-lockup-stacked-white-3000w.png"
        },
        {
          "colour": "ink",
          "svg": "/press-kit/logos/svg/atlas-lockup-stacked-ink.svg",
          "png": "/press-kit/logos/png/atlas-lockup-stacked-ink-3000w.png"
        }
      ]
    },
    {
      "id": "mark",
      "label": "Mark",
      "variants": [
        {
          "colour": "gold-gradient",
          "svg": "/press-kit/logos/svg/atlas-mark-gold-gradient.svg",
          "png": "/press-kit/logos/png/atlas-mark-gold-gradient-3000w.png"
        },
        {
          "colour": "gold",
          "svg": "/press-kit/logos/svg/atlas-mark-gold.svg",
          "png": "/press-kit/logos/png/atlas-mark-gold-3000w.png"
        },
        {
          "colour": "white",
          "svg": "/press-kit/logos/svg/atlas-mark-white.svg",
          "png": "/press-kit/logos/png/atlas-mark-white-3000w.png"
        },
        {
          "colour": "ink",
          "svg": "/press-kit/logos/svg/atlas-mark-ink.svg",
          "png": "/press-kit/logos/png/atlas-mark-ink-3000w.png"
        }
      ]
    },
    {
      "id": "wordmark",
      "label": "Wordmark",
      "variants": [
        {
          "colour": "gold",
          "svg": "/press-kit/logos/svg/atlas-wordmark-gold.svg",
          "png": "/press-kit/logos/png/atlas-wordmark-gold-3000w.png"
        },
        {
          "colour": "white",
          "svg": "/press-kit/logos/svg/atlas-wordmark-white.svg",
          "png": "/press-kit/logos/png/atlas-wordmark-white-3000w.png"
        },
        {
          "colour": "ink",
          "svg": "/press-kit/logos/svg/atlas-wordmark-ink.svg",
          "png": "/press-kit/logos/png/atlas-wordmark-ink-3000w.png"
        }
      ]
    }
  ],
  "screenshots": [
    {
      "file": "atlas-app-home.png",
      "caption": "Home: Outdoor Score, recent activity and next goals",
      "preview": "/press-kit/previews/screenshots/atlas-app-home.jpg",
      "width": 1179,
      "height": 2556
    },
    {
      "file": "atlas-app-map.png",
      "caption": "The map: everywhere recorded, with collected items in gold",
      "preview": "/press-kit/previews/screenshots/atlas-app-map.jpg",
      "width": 1179,
      "height": 2556
    },
    {
      "file": "atlas-app-collections.png",
      "caption": "Collections",
      "preview": "/press-kit/previews/screenshots/atlas-app-collections.jpg",
      "width": 1179,
      "height": 2556
    },
    {
      "file": "atlas-app-wainwrights.png",
      "caption": "A collection in progress: the Wainwrights",
      "preview": "/press-kit/previews/screenshots/atlas-app-wainwrights.jpg",
      "width": 1179,
      "height": 2556
    },
    {
      "file": "atlas-app-region.png",
      "caption": "Region coverage: the Lake District",
      "preview": "/press-kit/previews/screenshots/atlas-app-region.jpg",
      "width": 1179,
      "height": 2556
    },
    {
      "file": "atlas-app-achievements.png",
      "caption": "Achievements",
      "preview": "/press-kit/previews/screenshots/atlas-app-achievements.jpg",
      "width": 1179,
      "height": 2556
    },
    {
      "file": "atlas-app-statistics.png",
      "caption": "Statistics",
      "preview": "/press-kit/previews/screenshots/atlas-app-statistics.jpg",
      "width": 1179,
      "height": 2556
    },
    {
      "file": "atlas-app-matching.png",
      "caption": "Reviewing what an activity matched",
      "preview": "/press-kit/previews/screenshots/atlas-app-matching.jpg",
      "width": 1179,
      "height": 2556
    }
  ],
  "keyArt": [
    {
      "file": "atlas-cover-centred.png",
      "caption": "Cover, centred lockup",
      "preview": "/press-kit/previews/key-art/atlas-cover-centred.jpg",
      "width": 1640,
      "height": 624
    },
    {
      "file": "atlas-cover-minimal.png",
      "caption": "Cover, minimal",
      "preview": "/press-kit/previews/key-art/atlas-cover-minimal.jpg",
      "width": 1640,
      "height": 624
    },
    {
      "file": "atlas-cover-1200x630.png",
      "caption": "Cover, 1200 x 630",
      "preview": "/press-kit/previews/key-art/atlas-cover-1200x630.jpg",
      "width": 1200,
      "height": 630
    },
    {
      "file": "atlas-feature-graphic.png",
      "caption": "Feature graphic, 1024 x 500",
      "preview": "/press-kit/previews/key-art/atlas-feature-graphic.jpg",
      "width": 1024,
      "height": 500
    }
  ],
  "downloads": {
    "zip": "/press-kit/atlas-media-kit.zip",
    "zipBytes": 17813328,
    "factSheet": "/press-kit/atlas-fact-sheet.pdf"
  }
} as const;
